import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'results' ]

  connect() {
    this.pinIcon = L.icon({
      iconUrl: this.element.dataset.pinPath,
      iconAnchor: [24, 64]
    })

    this.latInput = document.querySelector('#article_latitude')
    this.lonInput = document.querySelector('#article_longitude')

    const mapEl = document.createElement('div')
    mapEl.style.height = "300px"
    mapEl.style.width = "100%"
    this.element.append(mapEl)

    const initialLatLng = this.formLatLng()
    this.map = L.map(mapEl).setView(initialLatLng || [50.1285663647049, 14.471028555510955], 10)

    L.tileLayer(`https://api.mapy.com/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=${MAPY_API_KEY}`, {
      minZoom: 0,
      maxZoom: 17,
      attribution: '<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
    }).addTo(this.map);

    if (initialLatLng) {
      this.placeMarker(initialLatLng, { recenter: false })
    }

    this.onMapClick = (e) => this.placeMarker([e.latlng.lat, e.latlng.lng])
    this.map.on('click', this.onMapClick)

    this.onCoordInputChange = () => {
      const ll = this.formLatLng()
      if (ll) this.placeMarker(ll, { silent: true })
    }
    this.latInput?.addEventListener('change', this.onCoordInputChange)
    this.lonInput?.addEventListener('change', this.onCoordInputChange)
  }

  disconnect() {
    this.latInput?.removeEventListener('change', this.onCoordInputChange)
    this.lonInput?.removeEventListener('change', this.onCoordInputChange)
  }

  formLatLng() {
    if (!this.latInput || !this.lonInput) return null
    const latField = parseFloat(this.latInput.value)
    const lonField = parseFloat(this.lonInput.value)
    if (Number.isNaN(latField) || Number.isNaN(lonField)) return null
    return [lonField, latField]
  }

  placeMarker(latlng, opts = {}) {
    if (this.marker) {
      this.marker.setLatLng(latlng)
    } else {
      this.marker = L.marker(latlng, { icon: this.pinIcon, draggable: true }).addTo(this.map)
      this.marker.on('dragend', (e) => {
        const ll = e.target.getLatLng()
        this.placeMarker([ll.lat, ll.lng], { recenter: false })
      })
    }

    if (opts.recenter !== false) {
      const targetZoom = Math.max(this.map.getZoom() || 0, 12)
      this.map.setView(latlng, targetZoom)
    }

    if (!opts.silent) {
      this.setLatLon(...latlng)
    }
  }

  async search(e) {
    const query = e.target.value;
    if (!query) return
    const response = await fetch(`https://api.mapy.cz/v1/suggest?lang=cs&apikey=${MAPY_API_KEY}&query=${query}&limit=5`)
    const results = await response.json()

    const positions = []
    let html = ''

    results.items.forEach(item => {
      positions.push([item.position.lat, item.position.lon])
      let description = [item.label, ...item.regionalStructure.slice(1).map(rs => rs.name)].join('; ')
      let countryCode = item.regionalStructure.find(e => e.isoCode)?.isoCode || ''

      html += `
        <a href='#' data-action="click->form_map#zoom" data-form_map-position-param="${JSON.stringify([item.position.lat, item.position.lon])}"  data-form_map-country-code-param="${countryCode}"> ${item.name}</a>
        <div class="text-muted"> ${description} </div>
      `
    })
    this.resultsTarget.innerHTML = html;

    if (positions.length) {
      this.map.fitBounds(positions, { padding: [20, 20] })
    }
  }

  zoom(e) {
    e.preventDefault()
    this.placeMarker(e.params.position)
    this.setCountryCode(e.params.countryCode)
  }

  setLatLon(lon, lat) {
    this.latInput.value = lat;
    this.lonInput.value = lon;
  }

  setCountryCode(code) {
    document.querySelector('#article_country_code').value = code;
  }

  preventSubmit(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.search(e)
    }
  }
}
